<template>
    <el-dialog :visible.sync="contactDialogVisible" @close="$emit('input', false)">
        <el-form :model="formData" ref="contactForm" :rules="rules">
            <el-row style="margin-bottom: 5px;" :gutter="20">
                <el-col :span="6" offset="6">
                    <el-form-item prop="name" label="姓名">
                        <el-input v-model="formData.name" placeholder="请输入联系人姓名"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item prop="cellphone" label="手机">
                        <el-input v-model="formData.cellphone" placeholder="请输入联系人手机号码"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 10px;" :gutter="20">
                <el-col :span="6" offset="6">
                    <el-form-item prop="dept" label="部门">
                        <el-input v-model="formData.dept" placeholder="请输入联系人部门"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item prop="email" label="邮箱">
                        <el-input v-model="formData.email" placeholder="请输入联系人邮箱"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 10px;" :gutter="20">
                <el-col :span="6" offset="6">
                    <el-form-item prop="position" label="岗位">
                        <el-input v-model="formData.position" placeholder="请输入联系人岗位"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item prop="telephone" label="固话">
                        <el-input v-model="formData.telephone" placeholder="请输入联系人固话"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 10px;" :gutter="20">
                <el-col :span="6" offset="6">
                    <el-form-item prop="level" label="职级">
                        <el-input v-model="formData.level" placeholder="请输入联系人职级"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item prop="other_contact_information" label="其他联系方式">
                        <el-input v-model="formData.other_contact_information" placeholder="其他联系方式"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 10px;" :gutter="20">
                <el-col :span="6" offset="6">
                    <el-form-item prop="gender" label="性别">
                        <el-select v-model="formData.gender" placeholder="请选择联系人性别">
                            <el-option label="男" value="男"></el-option>
                            <el-option label="女" value="女"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item prop="status" label="是否在职">
                        <el-select v-model="formData.status" placeholder="是否在职" value="1">
                            <el-option label="是" :value="1"></el-option>
                            <el-option label="否" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" offset="6">
                    <el-form-item prop="responsible_items" label="负责事项">
                        <el-input v-model="formData.responsible_items" type="textarea" placeholder=""></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" offset="6">
                    <el-form-item prop="other_describe" label="其他描述">
                        <el-input v-model="formData.other_describe" type="textarea" placeholder=""></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button :loading="loading" type="primary" @click="onSubmit('contactForm')">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {addClientContact} from '@/api/api'
export default {
    name: "ContactDialog",
    props: {
        value: {
            type: Boolean,
            default: false,
            required: true
        },
        clientId: {
            required: true
        }
    },
    data() {
        return {
            contactDialogVisible: false,
            loading: false,
            formData: {
                client_id: this.clientId,
                dept: "",
                position: "",
                level: "",
                status: "1",
                responsible_items: "",
                other_describe: "",
                name: "",
                gender: "",
                cellphone: "",
                email: "",
                telephone: "",
                other_contact_information: ""
            },
            rules: {
                name: [
                    {required: true, message: "请输入联系人名称", trigger: "blur"}
                ],
                status: [
                    {required: true, message: "请选择就职状态", trigger: "blur"}
                ]
            }
        }
    },

    watch: {
        value(newVal) {
            this.contactDialogVisible = newVal
        }
    },

    methods: {
        onSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if(valid) {
                    this.addClientContactAction()
                }else{
                    return false
                }
            });
        },

        async addClientContactAction() {
            this.loading = true
            let res = await addClientContact(this.formData)
            if(res.respCode&&res.respCode=='000000'){
                this.$message.success(res.respMsg)
                this.$emit('refresh', true)
                this.$nextTick(() => {
                    this.loading = false
                    this.$emit('input', false)
                })
            }else{
                this.$message.error(res.respMsg)
            }
        }
    }

}
</script>
<style scoped>
.el-dialog {
    width: 30%;
}
</style>
